import styled from "@emotion/styled";
import { Theme, Ui } from "@silvertours/front-shared";
// ToDo: use theme variables to ensure a unified design
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "e1orei6p0"
})("position:", function(param) {
    var isIntersecting = param.isIntersecting;
    return isIntersecting ? "fixed" : "relative";
}, ";top:0;left:0;width:100%;z-index:100;margin:0;display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:0.5rem 1rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.0625rem;font-weight:600;font-style:normal;line-height:1.5rem;&::after{content:'';display:none;width:100%;height:0.5em;}a:link{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-weight:700;}a:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}&.important{background-image:", function(param) {
    var theme = param.theme;
    return Theme.getLinearGradient(theme.gradient.orange, "to left");
}, ";}&.less-important{background-color:#c8c8c8;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";a:link{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}a:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}.close{fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}}&.regular-black{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}&.regular-green{background-image:", function(param) {
    var theme = param.theme;
    return "linear-gradient(to right,  ".concat(theme.color.primaryGradient1, ", ").concat(theme.color.primary, ")");
}, ";}.close{position:absolute;right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";background-color:transparent;width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";border:none;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;}", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{justify-content:center;}");
var CloseButton = /*#__PURE__*/ styled(Ui.IconButton, {
    target: "e1orei6p1"
})("position:absolute;right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
export { Wrapper, CloseButton };
